// export from UIKIT
import { useState } from 'react';

export const useDrawer = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerShow, setDrawerShow] = useState(true);

  const toggleDrawerOpen = () => {
    setDrawerShow(false);
      setTimeout(() => {
        setDrawerOpen(!drawerOpen);
        setDrawerShow(true);
      }, 100)
  }

  return {
    drawerOpen,
    drawerShow,
    toggleDrawerOpen
  }
}
